<template>
  <div>
    <div id="jumpCorrection" class="jumpCorrection"/>
    <div class="row">
      <div class="overviewAndNav mb-1">
        <h3>Overzicht klanten</h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="overviewAndNav">
            <h4>{{ selectedTimeSheetInfo.username }}</h4>
            <h4>{{ this.currentlySelectedMonth | toMonthNameWithYear }}</h4>
            <div>
              <button class="btn-basic btn-dark mr-2"
                  style="width: 50px;"
                  @click="previousMonth">
                <svg
                    class="bi bi-chevron-left" fill="currentColor"
                    height="1em" viewBox="0 0 16 16"
                    width="1em" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                      fill-rule="evenodd"/>
                </svg>
              </button>
              <button class="btn-basic btn-dark" @click="nextMonth"
                  style="width: 50px;">
                <svg
                    class="bi bi-chevron-right" fill="currentColor"
                    height="1em" viewBox="0 0 16 16"
                    width="1em" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                      fill-rule="evenodd"/>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div class="row">
          <table class="table table-bordered col calenderTable">
            <thead class="thead-dark">
            <tr>
              <th>Maandag</th>
              <th>Dinsdag</th>
              <th>Woensdag</th>
              <th>Donderdag</th>
              <th>Vrijdag</th>
              <th>Zaterdag</th>
              <th>Zondag</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="week in weeksToRender">
              <tr :key="weeksToRender.indexOf(week)">
                <template v-for="day in week">
                  <td :key="day.day" class="p-0">
                    <a
                        v-if="day.dateForId" :class="{selected: isSelected(day.dateForId)}"
                        class="calenderDay pointer"
                        @click="toggle(day.dateForId,  true)">
                      {{ day.day }}
                      <template v-for="(code, index) in day.codes">
                        <p :key="index" :style="{color: getColor(code)}">{{ code }}</p>
                      </template>
                    </a>
                    <a v-else class="calenderDay">{{ day.day }}</a>
                  </td>
                </template>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="row my-2">
      <h4>Detail overzicht</h4>
      <button
          v-if="isDownloading" class="btn btn-primary ml-auto"
          disabled>
        Downloading
      </button>
      <button
          v-else class="btn-basic btn-teal ml-auto mr-2"
          @click="downloadTimeSheetEBlox()">
        eBlox Formaat
      </button>
      <button
          v-if="isDownloading" class="btn-basic btn-green"
          disabled>
        Downloading
      </button>
      <button
          v-else class="btn-basic btn-green"
          @click="downloadTimeSheetCsv()">
        Download CSV
      </button>
    </div>
    <div class="row">
      <table class="table table-sm table-bordered col shiftsTable">
        <thead class="thead-dark">
        <tr>
          <SortableTableHeaderComponent
              columnName="date" :sortColumn="currentSortColumn"
              :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
              text="Dag" extraClasses="w-12_5"/>
          <SortableTableHeaderComponent
              columnName="code" :sortColumn="currentSortColumn"
              :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
              text="Code" extraClasses="w-12_5"/>
          <SortableTableHeaderComponent
              columnName="hoursWorked" :sortColumn="currentSortColumn"
              :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
              text="Uren" extraClasses="w-7_5"/>
          <SortableTableHeaderComponent
              columnName="codeDefinition" :sortColumn="currentSortColumn"
              :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
              text="Beschrijving" />
          <th scope="col">Actie</th>
        </tr>
        </thead>
        <tbody v-if="sortedTimeSheetDays">
        <template v-for="(timeSheetDay, index) in sortedTimeSheetDays">
          <AdminTimeSheetTableRowComponent :key="index" :timeSheetDay = "timeSheetDay" :index="index"/>
        </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import moment from "moment";
import codes from "@/constants/Codes";
import {toMonth, toYear} from "@/util/DateUtil";
import {sortListByColumnAndDirection} from "@/util/SortingUtil";
import SortableTableHeaderComponent from "@/components/tables/SortableTableHeader";
import AdminTimeSheetTableRowComponent from "@/Admin/AdminTimeSheetTableRowComponent/AdminTimeSheetTableRowComponent";

export default {
  name: "AdminViewTimeSheet",
  components: {
    AdminTimeSheetTableRowComponent,
    SortableTableHeaderComponent,
  },
  data: () => ({
    selectedShift: "",
    isDownloading: false,
    currentSortColumn: "date",
    currentSortDirectionAscending: true,
  }),
  computed: {
    ...mapGetters({
      selectedUserDetail: "administrationUser/selectedUserDetail",
      timeSheetDays: 'administrationTimeSheet/timeSheetDays',
      selectedTimeSheetInfo: 'administrationTimeSheet/selectedTimeSheetInfo',
      vacationTypes: "administrationUser/vacationTypes",
      currentlySelectedMonth: "time/currentlySelectedMonth"
    }),
    sortedTimeSheetDays() {
      if (this.currentSortColumn === "date") {
        return sortListByColumnAndDirection(this.timeSheetDays, this.currentSortColumn, this.currentSortDirectionAscending, this.dateToMillis);
      }
      return sortListByColumnAndDirection(this.timeSheetDays, this.currentSortColumn, this.currentSortDirectionAscending);
    },
    weeksToRender() {
      const month = toMonth(this.currentlySelectedMonth);
      const year = toYear(this.currentlySelectedMonth);
      const firstDayDateString = "1-" + month + "-" + year;
      const firstDayOfMonth = moment(firstDayDateString, "DD-MM-YYYY").locale('nl').weekday();
      const amountOfDaysInMonth = moment(firstDayDateString, "DD-MM-YYYY").daysInMonth();

      const emptyDaysInMonthAtStart = this.giveEmptyObjectsForDaysNotInMonthAtStart(firstDayOfMonth);
      const actualDaysInMonth = this.giveDayObjectsForDaysInMonth(amountOfDaysInMonth);
      const emptyDaysInMonthAtEnd = this.giveEmptyObjectsForDaysNotInMonthAtEnd(emptyDaysInMonthAtStart.length + actualDaysInMonth.length);

      const daysToRender = [
        ...emptyDaysInMonthAtStart,
        ...actualDaysInMonth,
        ...emptyDaysInMonthAtEnd
      ];

      return this.putListOfDaysIntoListOfWeeks(daysToRender);
    },
  },
  created() {
    this.fetchTimeSheetDays();
    this.fetchDetailsForSelectedUser();
    this.fetchRecupWithDeltasForSelectedUser();
    this.fetchVacationForSelectedUserAndCurrentYear();
  },
  methods: {
    ...mapActions("administrationTimeSheet", ["fetchTimeSheetDays", "downloadCsv", "downloadEBlox"]
    ),
    ...mapActions("administrationUser", [
      "fetchDetailsForSelectedUser",
      "fetchRecupWithDeltasForSelectedUser",
      "fetchVacationForSelectedUserAndCurrentYear",
      "updateLastRecupForSelectedUser",
      "updateProlongedSickLeaveForSelectedUser",
    ]),
    ...mapMutations({
      addMonth: "time/addMonth",
      subtractMonth: "time/subtractMonth"
    }),
    previousMonth() {
      this.selectedShift = "";
      this.subtractMonth();
      this.fetchTimeSheetDays();
    },
    nextMonth() {
      this.selectedShift = "";
      this.addMonth();
      this.fetchTimeSheetDays();
    },
    save() {
      this.isSaving = true;
      const endDate = this.updatedEndDate || undefined;
      const updateContractDto = {
        endDate
      };
      if (confirm("De einddatum van een contract aanpassen kan ertoe leiden dat alle timesheets na de einddatum van dit contract worden weggesmeten. Ben je zeker dat je de einddatum wil aanpassen?")) {
        this.updateContract({
          contractId: this.contractSummaryDto.id,
          updateContractDto,
          from: this.from
        })
            .then(() => {
              this.isSaving = false;
              this.isUpdateMode = false;
            }).catch(() => {
          this.isSaving = false;
          this.isUpdateMode = false;
        });
      } else {
        this.isSaving = false;
        this.isUpdateMode = false;
      }
    },
    toggle: function (props, withJump) {
      if (!props) return null;
      if (this.selectedShift === props) this.selectedShift = "";
      else {
        if (withJump) {
          document.getElementById(props).scrollIntoView(true);
        }
        this.selectedShift = props;
      }
    },
    toggleUpdateMode() {
      this.isUpdateMode = !this.isUpdateMode;
    },
    isSelected: function (props) {
      return this.selectedShift === props;
    },
    getColor: function (code) {
      return codes[code] || 'black';
    },
    formatDateFromString: function (date) {
      if (date) {
        return moment(date).locale('nl').format('DD-MM-YYYY');
      }
    },
    downloadTimeSheetCsv() {
      this.isDownloading = true;
      this.downloadCsv()
          .then(() => this.isDownloading = false)
          .catch(() => this.isDownloading = false);
    },
    downloadTimeSheetEBlox() {
      this.isDownloading = true;
      this.downloadEBlox()
          .then(() => this.isDownloading = false)
          .catch(() => this.isDownloading = false);
    },
    giveEmptyObjectsForDaysNotInMonthAtStart(firstDayOfMonth) {
      const result = [];
      for (let x = 0; x < firstDayOfMonth; x++) {
        result.push({});
      }
      return result;
    },
    giveDayObjectsForDaysInMonth(amountOfDaysInMonth) {
      const month = toMonth(this.currentlySelectedMonth);
      const year = toYear(this.currentlySelectedMonth);
      const result = [];

      for (let dayCounter = 1; dayCounter <= amountOfDaysInMonth; dayCounter++) {
        const dateString = dayCounter + "-" + month + "-" + year;
        const shiftsForThisDay = this.sortedTimeSheetDays.filter(
            timesheet => moment(timesheet.date).format("D-MM-YYYY") === dateString);
        const ascending = true;
        const shiftsForThisDaySortedByDate = sortListByColumnAndDirection([...shiftsForThisDay], "code", ascending);

        if (shiftsForThisDaySortedByDate.length === 0) {
          result.push(this.createDayObjectForDayWithoutShifts(dayCounter));
        } else {
          result.push(this.createDayObjectForDayWithShifts(dayCounter, shiftsForThisDaySortedByDate));
        }
      }
      return result;
    },
    createDayObjectForDayWithoutShifts(dayCounter) {
      return {
        day: dayCounter
      };
    },
    createDayObjectForDayWithShifts(dayCounter, shiftsForThisDay) {
      const codesForThisDay = [];
      shiftsForThisDay.forEach((element) => codesForThisDay.push(element.code));
      return {
        day: dayCounter,
        codes: codesForThisDay,
        dateForId: shiftsForThisDay[0].date,
      };
    },
    giveEmptyObjectsForDaysNotInMonthAtEnd(amountOfDaysToShow) {
      const result = [];
      const maxDistinctWeeksOccurringInASingleMonth = 6;
      const amountOfDaysInAWeek = 7;

      const maxDaysLeft = (maxDistinctWeeksOccurringInASingleMonth * amountOfDaysInAWeek) - amountOfDaysToShow;
      const actualDaysLeft = maxDaysLeft % amountOfDaysInAWeek;

      for (let x = 0; x < actualDaysLeft; x++) {
        result.push({});
      }
      return result;
    },
    putListOfDaysIntoListOfWeeks(days) {
      const amountOfDaysInAWeek = 7;
      const amountOfWeeksToCreate = days.length / amountOfDaysInAWeek;
      const result = [];

      for (let currentWeekIndex = 0; currentWeekIndex < amountOfWeeksToCreate; currentWeekIndex++) {
        const week = [];
        const startIndex = currentWeekIndex * amountOfDaysInAWeek;
        for (let currentDayIndex = startIndex; currentDayIndex < startIndex + amountOfDaysInAWeek; currentDayIndex++) {
          week.push(days[currentDayIndex]);
        }
        result.push(week);
      }
      return result;
    },
    dateToMillis(date) {
      return moment(date).valueOf();
    },
    sort: function (newSortColumn) {
      if (newSortColumn === this.currentSortColumn) {
        this.currentSortDirectionAscending = !this.currentSortDirectionAscending;
      } else {
        this.currentSortDirectionAscending = true;
      }
      this.currentSortColumn = newSortColumn;
    }
  },
};
</script>

<style scoped>
.overviewAndNav {
  margin-bottom: 20px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.calenderTable thead th {
  width: 14.2%;
}

.calenderTable tbody td {
  height: 90px;
}

.calenderDay {
  color: inherit;
  text-decoration: none;
  display: inline-block;
  width: 100%;
  height: 100%;
  padding: .5rem;
}

.calenderDay p {
  margin-bottom: 0;
}

.shiftsTable {
  margin-bottom: 4em;
}

.shiftsTable tbody tr:hover {
  background-color: aliceblue;
}

.pointer {
  cursor: pointer;
}

.pointer:hover {
  cursor: pointer;
  background-color: aliceblue;
}

.selected {
  background-color: aliceblue;
}

.jumpCorrection {
  position: absolute;
  top: 0;
}

.toTop {
  position: fixed;
  z-index: 10;
  bottom: 20px;
  right: 20px;
}

.w-12_5 {
  width: 12.5%;
}

.w-7_5 {
  width: 7.5%;
}

.w-67_5 {
  width: 67.5%;
}
</style>
